<template>

    <div class="registration-step-container">

        <section class="common">

            <div class="card_registration-step">
                <swiper class="swiper-container"
                    @swiper="onSwiper"
                    :pagination='{
                        "type": "progressbar"
                    }'

                    :effect="'fade'"
                    :slides-per-view="1"
                    :space-between="0"
                    :speed="1000"
                    :touchRatio="0"
                >
                    <swiper-slide v-if="shop">
                        <MembershipRegistrationShopStepPlan v-on:showNextSwiper="swiperNext" />
                    </swiper-slide>

                    <!-- TODO ショールーム・ショップ作成次第表示 -->
                    <swiper-slide v-if="brand || showroom || shop">
                        <MembershipRegistrationShopStep0 v-on:showNextSwiper="swiperNext" v-on:showPrevSwiper="swiperPrev" />
                    </swiper-slide>

                    <swiper-slide v-if="!shopPersonal">
                        <MembershipRegistrationShopStep1 v-on:showNextSwiper="swiperNext" v-on:showPrevSwiper="swiperPrev" />
                    </swiper-slide>


                    <swiper-slide>
                        <MembershipRegistrationShopStep2 v-on:setDisplayEmail="displayEmail" v-on:showNextSwiper="swiperNext" v-on:showPrevSwiper="swiperPrev" @openAlertModal="openAlertModal"/>
                    </swiper-slide>

                    <swiper-slide>
                        <MembershipRegistrationShopStep2A v-bind:displayEmail="verificationEmail" v-on:showPrevSwiper="swiperPrev" />
                    </swiper-slide>

                </swiper>
            </div>

        </section>

        <!--BackGround-->
        <div class="md_swiper-bg _fixed">
            <swiper
                :effect="'fade'"
                :slides-per-view="1"
                :space-between="0"
                :speed="3000"
                :autoplay='{
                    "delay": 5000,
                    "disableOnInteraction": false
                }'
            >
                <swiper-slide>
                    <img src="/img/registration/bg1.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?fashion" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Sweets" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store,white" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store,colorful" alt="">
                </swiper-slide>
            </swiper>
        </div>

    </div>
    <AlertModal
        v-if="showAlertModal"
        @close="closeAlertModal"
        :title="alert_modal_title"
        :message="alert_modal_message"
        :mode="alert_modal_mode"
    />
</template>


<script>
    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"
    import 'swiper/css/effect-fade';

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        EffectFade,
        Pagination,
        Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        EffectFade,
        Pagination,
        Navigation
    ]);

    //Common
    import EndUserLayout from '@/Layouts/EndUserLayout'

    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'

    //Svg
    import SvgIconShop from '@/components/EndUser/svg/SvgIconShop'

    //Step
    import MembershipRegistrationShopStepPlan from '@/components/EndUser/MembershipRegistrationShopStep/StepShopPlan'
    import MembershipRegistrationShopStep0 from '@/components/EndUser/MembershipRegistrationShopStep/Step0'
    import MembershipRegistrationShopStep1 from '@/components/EndUser/MembershipRegistrationShopStep/Step1'
    import MembershipRegistrationShopStep2 from '@/components/EndUser/MembershipRegistrationShopStep/Step2'
    import MembershipRegistrationShopStep2A from '@/components/EndUser/MembershipRegistrationShopStep/Step2A'

    export default {
        //Common
        layout: EndUserLayout,
        components: {
            //Swiper.js
            Swiper,
            SwiperSlide,
            SvgIconShop,
            //Step
            MembershipRegistrationShopStepPlan,
            MembershipRegistrationShopStep0,
            MembershipRegistrationShopStep1,
            MembershipRegistrationShopStep2,
            MembershipRegistrationShopStep2A,

            "AlertModal": AlertModal,
        },
        data() {
            return {
                verificationEmail: '',
                swiper: null,
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        mounted() {
            window.addEventListener('beforeunload', function(e) {
                e.preventDefault();
                e.returnValue = '他のページに移動しますか？';
            });

            window.addEventListener('pageshow',()=>{
                if(window.performance.navigation.type==2) location.reload();
            });
        },
        methods: {
            displayEmail(email) {
                this.verificationEmail = email;
            },
            onSwiper(swiper) {
                this.swiper = swiper;
            },
            swiperNext() {
                this.swiper.slideNext();
            },
            swiperPrev() {
                this.swiper.slidePrev();
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
        },
        computed: {
            shop() {
                return location.pathname.match(/^\/registration\/shop/);
            },
            shopPersonal() {
                if (this.$store.state.verify.form.registration_plan === 10) {
                    return true
                } else return false;
            },
            brand() {
                return location.pathname.match(/^\/registration\/brand/);
            },
            showroom() {
                return location.pathname.match(/^\/registration\/showroom/);
            },
        }

    };
</script>
